// Which credential the debug plane is asked with.
//
// Story VC-022. `agent_runtime_lld.md` §30.7.

/**
 * The credential to send to `/v1/sessions/{id}/debug/events`.
 *
 * §30.7 grants debug permission "by a second shared secret in a static
 * deployment, by a group in one with an identity provider". So what the
 * credential *is* depends on the deployment, and the page does not know
 * which one it is talking to.
 *
 * It does not need to, because the precedence is the same either way.
 * `?debug_token=` wins when it is there, since a page given one was given it
 * deliberately. Otherwise the session's own credential goes — which under an
 * identity provider is the access token whose `debug.read` group is the
 * grant, and in a static deployment is a session token carrying no debug
 * scope, refused with 403.
 *
 * That 403 is §30.7 working rather than failing. The separation it asks for
 * — that authenticating a session must not, by itself, authorise reading its
 * debug stream — is enforced by the server in both deployments, so the page
 * cannot weaken it by choosing wrongly here.
 *
 * @param {{ debugToken?: string, sessionToken?: string }} credentials
 * @returns {string} empty when there is nothing to send
 */
export function debugCredential({ debugToken, sessionToken }) {
  return debugToken || sessionToken || "";
}
